import React, { useState } from 'react';
import styled from 'styled-components';

const LogicalThinking = ({ text }) => {
  const [expanded, setExpanded] = useState(false);

  if (!text || text.trim().length === 0) return null;

  return (
    <Container>
      <ToggleButton onClick={() => setExpanded(!expanded)}>
        <Icon>{expanded ? '▼' : '▶'}</Icon>
        <Title>Logical Thinking Process</Title>
        <Badge>AI Reasoning</Badge>
      </ToggleButton>
      
      {expanded && (
        <ContentContainer>
          <ThinkingIcon>🧠</ThinkingIcon>
          <ThinkingText>{text}</ThinkingText>
        </ContentContainer>
      )}
    </Container>
  );
};

export default LogicalThinking;

const Container = styled.div`
  margin: 1rem 0;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  background: #f9f9f9;
`;

const ToggleButton = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background: #f0f0f0;
  border: none;
  cursor: pointer;
  transition: background 0.2s;
  
  &:hover {
    background: #e8e8e8;
  }
`;

const Icon = styled.span`
  font-size: 0.8rem;
  color: #666;
`;

const Title = styled.span`
  font-weight: 600;
  color: #333;
  flex-grow: 1;
  text-align: left;
`;

const Badge = styled.span`
  background: #9C27B0;
  color: white;
  padding: 0.25rem 0.5rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 500;
`;

const ContentContainer = styled.div`
  padding: 1.5rem;
  background: white;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const ThinkingIcon = styled.div`
  font-size: 2rem;
  text-align: center;
  opacity: 0.8;
`;

const ThinkingText = styled.div`
  color: #444;
  font-size: 0.95rem;
  line-height: 1.7;
  white-space: pre-wrap;
  word-wrap: break-word;
  padding: 1rem;
  background: #f8f4ff;
  border-left: 4px solid #9C27B0;
  border-radius: 4px;
`;
